import React from 'react'
import { Alert, AlertTitle, Typography } from '@mui/material'
import { ApiErrorDescription } from '../utils/apiError'

/** Shows a failed api call in full: the api's own message (which for e-Bulk says what to do), its type and id. */
const ApiErrorAlert: React.FC<{ error: ApiErrorDescription, onClose?: () => void }> = ({ error, onClose }) => (
  <Alert severity="error" onClose={onClose} sx={{ marginTop: 1 }} data-testid="api-error">
    <AlertTitle>{error.title}</AlertTitle>
    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>{error.message}</Typography>
    {(error.type || error.id) && (
      <Typography variant="caption" color="text.secondary" component="div" sx={{ marginTop: 1, fontFamily: 'monospace' }}>
        {[error.type, error.id ? `id ${error.id}` : undefined].filter(Boolean).join(' · ')}
      </Typography>
    )}
  </Alert>
)

export default ApiErrorAlert
